import httpExceptionInterceptor from "./HttpExceptionInterceptor";

var httpExceptionInterceptorProvider = angular.module('httpExceptionInterceptorProvider', []);
httpExceptionInterceptorProvider.factory( 'httpExceptionInterceptorFactory', httpExceptionInterceptor );
httpExceptionInterceptorProvider.config(["$httpProvider", function($httpProvider) {
  $httpProvider.interceptors.push('httpExceptionInterceptorFactory');
}]);

export default httpExceptionInterceptorProvider;